import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Lock, ArrowLeft, CalendarClock } from "lucide-react";
import Layout from "../components/Layout";
import api, { mediaUrl } from "../lib/api";

export default function TrainingDetail() {
  const { id } = useParams();
  const [tr, setTr] = useState(null);
  useEffect(() => { api.get("/trainings").then((r) => setTr(r.data.find((t) => t.id === id))); }, [id]);

  if (!tr) return <Layout><div className="section-pad text-center text-brand-muted">Loading…</div></Layout>;

  return (
    <Layout>
      <div className="section-pad max-w-3xl mx-auto">
        <Link to="/trainings" className="inline-flex items-center gap-2 text-brand-sage text-sm mb-6"><ArrowLeft size={16} /> All Trainings</Link>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-brand-ink">{tr.title}</h1>
        <img src={mediaUrl(tr.thumbnail)} alt={tr.title} className="rounded-2xl w-full aspect-video object-cover mt-6" />
        <p className="mt-6 text-lg text-brand-inksoft leading-relaxed">{tr.teaser}</p>

        {tr.unlocked ? (
          <div className="mt-6 space-y-4 text-brand-inksoft leading-relaxed" data-testid="training-body">
            <p>{tr.body}</p>
          </div>
        ) : (
          <div className="mt-8 card-surface p-8 text-center bg-brand-cream2" data-testid="training-paywall">
            <Lock size={32} className="text-brand-gold mx-auto" />
            <h3 className="font-display text-2xl font-semibold text-brand-ink mt-3">Unlock the full training</h3>
            <p className="text-brand-inksoft text-sm mt-2 max-w-md mx-auto">This complete program is part of Diamond Dharma. Unlock it — plus every video, reflection, and all three trainings — for a one-time $50 lifetime payment.</p>
            <Link to="/packages?tier=diamond&checkout=true" className="btn-gold mt-5" data-testid="training-unlock-cta">Unlock with Diamond Dharma — $50 lifetime</Link>
          </div>
        )}

        {tr.discovery_cta && (
          <div className="mt-8 card-surface p-6 flex flex-wrap items-center justify-between gap-4">
            <div>
              <h4 className="font-semibold text-brand-ink flex items-center gap-2"><CalendarClock size={18} className="text-brand-sage" /> Free 20-Minute Discovery Lesson</h4>
              <p className="text-sm text-brand-muted mt-1">Available to every member — book a free discovery communication session with Seymour.</p>
            </div>
            <Link to="/dashboard" className="btn-outline !py-2 text-sm" data-testid="discovery-booking">Book Discovery Call</Link>
          </div>
        )}
      </div>
    </Layout>
  );
}
